import { render } from "./DetailSender.vue?vue&type=template&id=e6d65a8c"
import script from "./DetailSender.vue?vue&type=script&lang=js"
export * from "./DetailSender.vue?vue&type=script&lang=js"

import "./DetailSender.vue?vue&type=style&index=0&id=e6d65a8c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__